// src/services/PaymentManagement/index.ts
import { useQuery } from 'react-query';
import { api } from '../constants';
import { AxiosInstance } from '../axios.config';
import {
  ICommissionResponse,
  ICustomerPaymentHistoryResponse,
  IGetPaymentHistoryParams,
  IPaymentHistoryResponse,
  IRemainingPaymentResponse,
} from './types';

const getVendorPaymentHistory = async (
  params: IGetPaymentHistoryParams,
): Promise<IPaymentHistoryResponse> => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v != null && v !== ''),
  );

  const response = await AxiosInstance.get(api.payment.vendorHistory, {
    params: filteredParams,
  });

  return response.data;
};

export const useGetVendorPaymentHistory = (params: IGetPaymentHistoryParams) => {
  return useQuery<IPaymentHistoryResponse, Error>({
    queryKey: ['vendorPaymentHistory', params],
    queryFn: () => getVendorPaymentHistory(params),
    keepPreviousData: true,
  });
};

const getCustomerPaymentHistory = async (
  params: IGetPaymentHistoryParams,
): Promise<ICustomerPaymentHistoryResponse> => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v != null && v !== ''),
  );

  const response = await AxiosInstance.get(api.payment.customerHistory, {
    params: filteredParams,
  });

  return response.data;
};

export const useGetCustomerPaymentHistory = (params: IGetPaymentHistoryParams) => {
  return useQuery<ICustomerPaymentHistoryResponse, Error>({
    queryKey: ['customerPaymentHistory', params],
    queryFn: () => getCustomerPaymentHistory(params),
    keepPreviousData: true,
  });
};

const getCommissionRate = async (): Promise<ICommissionResponse> => {
  const response = await AxiosInstance.get(api.commission);
  return response.data;
};

export const useGetCommissionRate = () => {
  return useQuery<ICommissionResponse, Error>({
    queryKey: ['commissionRate'],
    queryFn: () => getCommissionRate(),
    staleTime: 1000 * 60 * 10, //10 minutes
    cacheTime: 1000 * 60 * 20, //20 minutes
  });
};

const getVendorRemainingPayment = async (): Promise<IRemainingPaymentResponse> => {
  const response = await AxiosInstance.get(api.payment.remainingPayment);
  return response.data;
};

export const useGetVendorRemainingPayment = () => {
  return useQuery<IRemainingPaymentResponse, Error>({
    queryKey: ['vendorRemainingPayment'],
    queryFn: getVendorRemainingPayment,
    staleTime: 1000 * 60 * 5, // 5 minutes, adjust as needed
  });
};
